<template>
    <v-layout column fill-height>
        <breadcrumbs v-on:selectTab="changeTab" guia="Sinistro" titulo="Sinistro" descricao="Acompanhe o andamento dos processos abertos e tenha acesso fácil aos formulários necessários." :tabs="tabOptions" />

        <v-layout class="main">
            <Acompanhamento v-if="tab == 1" />
            <Formularios v-if="tab == 2" />
        </v-layout>

    </v-layout>
</template>


<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import Acompanhamento from "@/components/portal/sinistro/Acompanhamento";
import Formularios from "@/components/portal/sinistro/Formularios";


export default {
  components: {
    breadcrumbs,
    Acompanhamento,
    Formularios
  },
  data() {
    return {
        tab:1,
        guia: "Sinistro > Acompanhamento Online",
        tabOptions: [
            { id: 1, titulo: "Acompanhamento Online"},
            { id: 2, titulo: "Formulários"},
        ]    
    }
  },
  methods: {
      changeTab(value){
          this.tab = value;
          this.guia = "Sinistro > " + this.tabOptions[value - 1].titulo;
      }
  },
};
</script>